import { FormDropdown, FormTextArea } from 'components/shared/Forms/ReduxForm'
import config from 'config/config'
import { I18n } from 'lib/i18n'
import {
  classNames,
  sortableListDragSource,
  sortableListDropTargetNew,
} from 'lib/utilities'
import PropTypes from 'prop-types'
import React from 'react'
import { DragSource, DropTarget } from 'react-dnd'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { change, Field, formValues } from 'redux-form'
import { createPropertyValue } from 'redux/product'
import {
  Button,
  Divider,
  Header,
  Icon,
  List,
  Loader,
  Table,
} from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  const { propertiesLoading } = state.properties
  return { propertiesLoading }
}

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ createPropertyValue, change }, dispatch)

class ProductPropertyRow extends React.Component {
  static propTypes = {
    as: PropTypes.string,
    name: PropTypes.string,
    propNameDe: PropTypes.string,
    propNameFr: PropTypes.string,
    optionsDe: PropTypes.array,
    optionsFr: PropTypes.array,
    nameDe: PropTypes.string,
    nameFr: PropTypes.string,
    propertyId: PropTypes.number,
    initialize: PropTypes.func,
    deleteRow: PropTypes.func,
    index: PropTypes.number,
    dragId: PropTypes.any,
    deleteMedium: PropTypes.func,
    isDragging: PropTypes.bool,
    connectDragSource: PropTypes.func,
    connectDropTarget: PropTypes.func,
    moveItem: PropTypes.func, //sortableListDropTarget uses it, do not change name!
  }

  constructor(props) {
    super(props)
    this.state = { newValue: false }
  }

  componentWillReceiveProps(newProps) {
    const { propertiesLoading: propertiesLoadingNew } = newProps
    const { propertiesLoading: propertiesLoadingOld } = this.props
    if (this.state.newValue && propertiesLoadingOld && !propertiesLoadingNew) {
      this.setState({ newValue: false })
    }
  }

  getText() {
    const {
      productProperty,
      as,
      editRow,
      isDragging,
      sortable,
      dragMarker = {},
    } = this.props
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.position === 'above') dragIndicator = 'dragAbove'
    if (dragMarker.position === 'below') dragIndicator = 'dragBelow'
    const CSSClassNames = classNames([
      rowClass,
      dragIndicator,
      as,
      as === 'category' && 'warning',
      'top aligned',
    ])
    const items_de = productProperty.value_de.split('\n')
    const items_fr = productProperty.value_fr.split('\n')
    return (
      <tr className={CSSClassNames} width={5}>
        <Table.Cell
          collapsing
          {...(sortable
            ? {
                className: 'draggable',
                content: <Icon {...config.icons.draggable} link />,
              }
            : {})}
        />
        <Table.Cell>
          <Header size="tiny" children={I18n.t('global.free_text')} />
          <List bulleted={items_de && items_de.length > 1} items={items_de} />
        </Table.Cell>
        <Table.Cell className="secondary" width={5}>
          <Header size="tiny" children={I18n.t('global.free_text')} />
          <List bulleted={items_fr && items_fr.length > 1} items={items_fr} />
        </Table.Cell>
        <Table.Cell textAlign="right" width={2} verticalAlign="middle">
          <Icon {...config.icons.edit} onClick={editRow} link />
        </Table.Cell>
      </tr>
    )
  }

  getTextEditing() {
    const { as, nameDe, nameFr, deleteRow, clearRow } = this.props
    const CSSClassNames = classNames([
      as,
      as === 'category' && 'warning',
      'top aligned',
    ])
    return (
      <tr className={CSSClassNames} width={5}>
        <Table.Cell collapsing />
        <Table.Cell>
          <Header size="tiny" children={I18n.t('global.free_text')} />
          <Field
            component={FormTextArea}
            name={nameDe}
            placeholder={I18n.t('global.please_select')}
            className="german"
          />
        </Table.Cell>
        <Table.Cell className="secondary" width={5}>
          <Header size="tiny" children={I18n.t('global.free_text')} />
          <Field
            component={FormTextArea}
            name={nameFr}
            placeholder={I18n.t('global.please_select')}
            className="german"
          />
        </Table.Cell>
        <Table.Cell textAlign="right" width={2} verticalAlign="middle">
          <Icon
            size="large"
            {...config.icons.confirm}
            onClick={clearRow}
            link
          />
          <Icon
            link
            {...config.icons.delete}
            size="large"
            onClick={deleteRow}
          />
        </Table.Cell>
      </tr>
    )
  }

  getProperty() {
    const {
      propertyValue,
      as,
      propNameDe,
      propNameFr,
      editRow,
      isDragging,
      sortable,
      readOnly,
      dragMarker = {},
    } = this.props
    let rowClass = isDragging && 'isDragging'
    let dragIndicator
    if (dragMarker.position === 'above') dragIndicator = 'dragAbove'
    if (dragMarker.position === 'below') dragIndicator = 'dragBelow'
    const CSSClassNames = classNames([
      rowClass,
      dragIndicator,
      as,
      as === 'category' && 'warning',
      'top aligned',
    ])
    const items_de =
      propertyValue.value_de && propertyValue.value_de.split('\n')
    const items_fr =
      propertyValue.value_fr && propertyValue.value_fr.split('\n')
    return (
      <tr className={CSSClassNames} width={5}>
        <Table.Cell
          collapsing
          {...(sortable
            ? {
                className: 'draggable',
                content: <Icon {...config.icons.draggable} link />,
              }
            : {})}
        />
        <Table.Cell>
          <Header size="tiny" children={propNameDe} />
          <List bulleted={items_de && items_de.length > 1} items={items_de} />
        </Table.Cell>
        <Table.Cell className="secondary" width={5}>
          <Header size="tiny" children={propNameFr} />
          <List bulleted={items_fr && items_fr.length > 1} items={items_fr} />
        </Table.Cell>
        <Table.Cell textAlign="right" width={2} verticalAlign="middle">
          {!readOnly && <Icon {...config.icons.edit} onClick={editRow} link />}
        </Table.Cell>
      </tr>
    )
  }

  getPropertyEditing() {
    const {
      as,
      name,
      propNameDe,
      propNameFr,
      optionsDe,
      optionsFr,
      propertyId,
      index,
      form,
      propertiesLoading,
    } = this.props
    const { newValueDe, newValueFr } = this.props //formValues
    const { deleteRow, clearRow, createPropertyValue, change } = this.props
    const { newValue } = this.state
    const CSSClassNames = classNames([
      as,
      as === 'category' && 'warning',
      'top aligned',
    ])
    return newValue && propertiesLoading ? (
      <tr className={CSSClassNames}>
        <Table.Cell colSpan={4}>
          <Loader inline />
        </Table.Cell>
      </tr>
    ) : (
      <tr className={CSSClassNames}>
        <Table.Cell collapsing />
        <Table.Cell>
          <Field
            {...{
              component: FormDropdown,
              name: name,
              options: optionsDe,
              placeholder: I18n.t('navigation.languages.de'),
              className: 'german',
              label: propNameDe,
            }}
            selection
            search
            noError
          />
          {newValue && (
            <Field
              component={FormTextArea}
              name="newValueDe"
              placeholder={I18n.t('navigation.languages.de')}
              className="german"
            />
          )}
        </Table.Cell>
        <Table.Cell className="secondary" width={5}>
          <Field
            {...{
              component: FormDropdown,
              name: name,
              options: optionsFr,
              placeholder: I18n.t('navigation.languages.fr'),
              className: 'french',
              label: propNameFr,
            }}
            selection
            search
            noError
          />
          {newValue && (
            <Field
              component={FormTextArea}
              name="newValueFr"
              placeholder={I18n.t('navigation.languages.fr')}
              className="french"
            />
          )}
        </Table.Cell>
        <Table.Cell textAlign="right" width={2} verticalAlign="middle">
          <Icon
            size="large"
            {...config.icons.confirm}
            onClick={() => {
              this.setState({ newValue: false })
              clearRow()
            }}
            link
          />
          <Icon
            onClick={(event) => {
              event.preventDefault()
              this.setState({ newValue: true })
              change(form, 'newValueDe', '')
              change(form, 'newValueFr', '')
            }}
            {...config.icons.add}
            link
            size="large"
          />
          {as === 'category' ? (
            <Icon size="large" {...config.icons.locked} />
          ) : (
            <Icon
              size="large"
              {...config.icons.delete}
              onClick={deleteRow}
              link
            />
          )}
          {newValue && (
            <div>
              <Divider hidden />
              <Button
                content={I18n.t('global.save')}
                size="tiny"
                color={newValueDe && newValueFr && 'orange'}
                disabled={!newValueDe || !newValueFr}
                onClick={() => {
                  createPropertyValue(form, {
                    index: index,
                    property_id: propertyId,
                    value_de: newValueDe,
                    value_fr: newValueFr,
                  })
                }}
                link
              />
            </div>
          )}
        </Table.Cell>
      </tr>
    )
  }

  render() {
    const { as, editing, sortable } = this.props
    const { connectDragSource, connectDropTarget } = this.props

    switch (as) {
      case 'text':
        return connectDragSource(
          connectDropTarget(editing ? this.getTextEditing() : this.getText())
        )
      default:
        if (sortable && !editing)
          return connectDragSource(connectDropTarget(this.getProperty()))
        else return editing ? this.getPropertyEditing() : this.getProperty()
    }
  }
}

ProductPropertyRow = DropTarget(
  'ProductProperty',
  sortableListDropTargetNew,
  (connect) => ({ connectDropTarget: connect.dropTarget() })
)(ProductPropertyRow)
ProductPropertyRow = DragSource(
  'ProductProperty',
  sortableListDragSource,
  (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    isDragging: monitor.isDragging(),
  })
)(ProductPropertyRow)
ProductPropertyRow = formValues('newValueDe', 'newValueFr')(ProductPropertyRow)
ProductPropertyRow = connect(mapStateToProps, mapDispatchToProps)(
  ProductPropertyRow
)
export default ProductPropertyRow



// WEBPACK FOOTER //
// ./src/components/admin/Products/Segments/ProductPropertyRow.jsx